/**
 * Custom hook for fetching SCORM manifest and constructing URLs
 */

import { useState, useEffect } from 'react';
import { fetchScormManifest } from '@/services/ScormService';
import { getLessonContentBaseUrl } from '@/utils/assetUrl';

export const useScormUrl = (packageName: string | undefined) => {
  const [scormUrl, setScormUrl] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!packageName) {
      setScormUrl('');
      return;
    }

    const fetchUrl = async () => {
      setLoading(true);
      setError(null);

      try {
        const manifest = await fetchScormManifest(packageName);
        const baseUrl = getLessonContentBaseUrl();
        const url = `${baseUrl}/scorm_packages/${packageName}/${manifest.entryPoint}`;

        console.log(`SCORM URL resolved: ${manifest.entryPoint} for package ${packageName}`);
        setScormUrl(url);
      } catch (err: any) {
        console.error('Error fetching SCORM URL:', err);
        setError(err.message || 'Failed to load SCORM content');

        // Fallback to story.html
        const baseUrl = getLessonContentBaseUrl();
        setScormUrl(`${baseUrl}/scorm_packages/${packageName}/story.html`);
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, [packageName]);

  return { scormUrl, loading, error };
};
